/* src/app/modules/home/components/topnav/topnav.component.scss */
.ddlogo {
  cursor: pointer;
  text-decoration: none;
}
.dd-action-container {
  display: inline-flex;
  width: 100%;
  height: 100%;
  align-items: center;
  margin-left: 4rem;
  justify-content: space-between;
}
.dd-action-container .project-select button {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  height: 3rem;
}
.dd-action-container .project-select button .project-select-image img {
  height: 2rem;
}
.dd-action-container .project-select button .project-select-icon {
  display: inline-flex;
  align-items: end;
  gap: 0.3rem;
}
.dd-action-container .project-select button .project-select-icon .material-symbols-outlined {
  margin-left: -0.5rem;
  font-size: 1.3rem;
}
.dd-action-container .project-select button .project-select-icon .project-name {
  font-size: 1rem;
}
.dd-action-container .dd-right-side-actions {
  display: inline-flex;
  align-items: center;
}
.dd-action-container .dd-right-side-actions .dd-profile-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  height: 3rem;
}
.dd-action-container .dd-right-side-actions .dd-profile-btn .profile-info {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}
.dd-action-container .dd-right-side-actions .dd-profile-btn .profile-info .material-symbols-outlined {
  color: var(--mdc-icon-button-icon-color);
  font-size: 2.5rem;
  margin-left: -0.8rem;
  margin-top: 0.1rem;
}
.dd-action-container .dd-right-side-actions .dd-profile-btn .profile-info .profile-name-info {
  display: inline-flex;
  flex-direction: column;
  align-items: baseline;
}
.dd-action-container .dd-right-side-actions .dd-profile-btn .profile-info .profile-name-info .profile-name {
  font-size: 0.9rem;
  color: var(--mdc-icon-button-icon-color);
}
.dd-action-container .dd-right-side-actions .dd-profile-btn .profile-info .profile-name-info .profile-position {
  font-size: 0.7rem;
  margin-top: -0.25rem;
  color: var(--mdc-icon-button-icon-color);
}
.dd-action-container .dd-right-side-actions .dd-profile-btn .mat-icon {
  color: var(--mdc-icon-button-icon-color);
}
.dd-action-container .dd-right-side-actions .dd-notifications-badge ::ng-deep .p-badge {
  top: 10%;
  right: 10%;
}
.notifications-dialog {
  position: relative;
}
.notifications-dialog ::ng-deep .p-dialog-header {
  padding: 0;
}
.notifications-dialog ::ng-deep .p-dialog-content {
  margin-right: -1rem;
  padding-right: 1rem;
  margin-block: 0.5rem;
}
.notifications-dialog .notif-header ::ng-deep span.p-dropdown-label {
  font-size: 0.75rem;
  padding: 0.5rem;
  padding-right: 1rem;
}
.notifications-dialog .notif-header ::ng-deep .p-dropdown .p-dropdown-clear-icon {
  right: 1.5rem;
  width: 0.75rem;
}
.notifications-dialog .notif-header ::ng-deep svg.p-dropdown-trigger-icon {
  height: 0.75rem;
}
.notifications-dialog .notif-header ::ng-deep .p-button-label {
  font-size: 0.75rem;
}
.notifications-dialog .notif-header ::ng-deep .p-button {
  padding: 0.5rem;
}
.select-project-container .projects-list .project-item.selected {
  background-color: var(--primary-100);
}
.select-project-container .projects-list .project-item.selected:hover {
  background-color: var(--primary-100) !important;
}
.select-project-container .projects-list .material-symbols-outlined {
  max-width: 3rem;
}
.select-project-container .projects-list ::ng-deep .p-progress-spinner:before {
  color: var(--primary-500) !important;
}
.select-project-container .projects-list ::ng-deep .p-inputtext {
  font-size: 0.875rem;
}
.spinner svg {
  width: 6rem;
  transform-origin: center;
  animation: rotate4 2s linear infinite;
}
.spinner circle {
  fill: none;
  stroke: var(--primary-color);
  stroke-width: 2;
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: dash4 1.5s ease-in-out infinite;
}
@keyframes rotate4 {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash4 {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dashoffset: -125px;
  }
}
::ng-deep .custom-dropdown-panel ::ng-deep .p-dropdown-item {
  font-size: 0.875rem;
  padding: 1rem;
}
.project-btn-logo {
  max-width: 6rem;
  max-height: 2rem;
  object-fit: contain;
  display: block;
}
::ng-deep .project-switch-dialog .p-dialog-header {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--surface-200);
}
::ng-deep .project-switch-dialog .p-dialog-header .p-dialog-title {
  font-size: 1.1rem;
  font-weight: 600;
}
::ng-deep .project-switch-dialog .p-dialog-content {
  padding: 1.25rem 1.5rem;
  overflow-y: auto;
}
::ng-deep .p-dialog-mask.p-component-overlay {
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
}
.project-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
  gap: 1rem;
}
.project-card {
  border: 1px solid var(--surface-200);
  transition: all 0.2s ease;
  min-height: 7rem;
}
.project-card:hover {
  border-color: var(--primary-300);
  background-color: var(--primary-50);
}
.project-card.selected {
  border-color: var(--primary-400);
  background-color: var(--primary-50);
}
.project-card .project-card-image {
  width: 4rem;
  height: 3rem;
}
.project-card .project-card-image .project-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.project-card .project-card-image .project-initials {
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-50);
  border-radius: 50%;
}
/*# sourceMappingURL=topnav.component.css.map */
